import { resolveMasteryColorForPercentage } from "@memorang/helpers/common";
import { useAppConfig } from "../../contexts/AppConfigContext";
import { useAppTheme } from "../../useAppTheme";
import { FlatChip } from "../FlatChip";
import { getMasteryChipColors } from "../MasteryChip";

export type ScoreChipProps = {
	isCorrect: boolean;
	isSkipped: boolean;
	scorePercentage: number;
	value: string;
	minWidth?: number;
};

export const ScoreChip = ({
	isCorrect,
	isSkipped,
	scorePercentage,
	value,
	minWidth = 52,
}: ScoreChipProps) => {
	const theme = useAppTheme();
	const { masteryLevels } = useAppConfig();

	const masteryColor = isSkipped
		? undefined
		: resolveMasteryColorForPercentage(
				scorePercentage,
				masteryLevels,
				theme.dark,
			);

	if (masteryColor) {
		const { backgroundColor, textColor } = getMasteryChipColors(masteryColor);
		return (
			<FlatChip
				label={value}
				backgroundColor={backgroundColor}
				textColor={textColor}
				minWidth={minWidth}
			/>
		);
	}

	const backgroundColor = isSkipped
		? theme.colors.secondaryContainer
		: isCorrect
			? theme.palette.success.info
			: theme.colors.errorContainer;

	return (
		<FlatChip
			label={value}
			backgroundColor={backgroundColor}
			minWidth={minWidth}
		/>
	);
};
